module.exports = __webpack_public_path__ + "img/证书8.7070a14a.png";